@if (!isLoading) {
    @if (standalone) {
        <app-header/>
        <ion-content>
            <ng-container *ngTemplateOutlet="exceptionDetails"></ng-container>
        </ion-content>
    } @else {
        <div>
            <ng-container *ngTemplateOutlet="exceptionDetails"></ng-container>
        </div>
    }

    <ng-template #exceptionDetails>
        <app-error-detail-template [error]="error!" (errorTypeUpdated)="updateErrorType($event)"
                                   [solveError]="solveError">
            <app-error-detail-rule ruleNameKey="components.errorDetails.errorCardDetails.ruleName.message"
                                   [content]="error!.message"/>
            <app-error-detail-rule ruleNameKey="components.errorDetails.errorCardDetails.ruleName.stackTrace"
                                   [content]="error!.stackTrace ?? 'error.stackTrace.unknown' | translate "/>
        </app-error-detail-template>
    </ng-template>
}
